export function formatEta(minutes: number | null): string {
  if (minutes == null) return "ETA pending";
  if (minutes <= 1) return "Arriving now";
  if (minutes < 60) return `~${Math.round(minutes)} min away`;
  const h = Math.floor(minutes / 60);
  const m = Math.round(minutes % 60);
  return m === 0 ? `~${h} hr away` : `~${h} hr ${m} min away`;
}

export function formatRelative(iso: string, now: Date = new Date()): string {
  const then = new Date(iso).getTime();
  const diffSec = Math.max(0, Math.round((now.getTime() - then) / 1000));
  if (diffSec < 10) return "just now";
  if (diffSec < 60) return `${diffSec}s ago`;
  const min = Math.round(diffSec / 60);
  if (min < 60) return `${min} min ago`;
  const hr = Math.round(min / 60);
  return `${hr} hr ago`;
}

export function shortenTechName(full: string): string {
  // "Mike Rodriguez" -> "Mike R."; "Mike" -> "Mike"
  const parts = full.trim().split(/\s+/);
  if (parts.length === 1) return parts[0];
  return `${parts[0]} ${parts[parts.length - 1][0]}.`;
}
